import { AsyncAction } from 'actions/actions.types'
import {
  commonPaymentAction,
  togglePaymentLoadingAction,
} from 'actions/storefront/paymentStorefrontAction'
import { AsyncThunkAction } from 'actions/types'
import { ApiResult } from 'api/fetchApi'
import { definitions } from 'api/generated/photorating'
import { fetchPhotoRatingActiveListApi } from 'api/rating/featuredPhotosApi'
import { fetchArchivedFeaturedPhotoApi } from 'api/rating/fetchArchivedFeaturedPhotoApi'
import { placeFeaturedPhotosOrderApi } from 'api/salesApi'
import { StorefrontService } from 'components/storefront/StoreFront.constants'
import { Status } from 'reducers/featuredPhotos/FeaturedPhotosPopularityState'

import { AppDispatchNext, AppGetState } from './actions.typesNext'

export const PLACE_FEATURED_PHOTOS_ORDER = 'PLACE_FEATURED_PHOTOS_ORDER'

const placeFeaturedPhotosOrderAction =
  (impressions) => async (dispatch: AppDispatchNext, getState: AppGetState) => {
    const {
      featuredPhotosStoreFront: { prospectPhotos, selectedPhotoIndex },
      paymentStorefrontReducer: { paymentOrderId },
    } = getState()
    const selectedPhoto = prospectPhotos[selectedPhotoIndex]
    return dispatch({
      type: PLACE_FEATURED_PHOTOS_ORDER,
      promise: () =>
        placeFeaturedPhotosOrderApi(
          paymentOrderId,
          selectedPhoto.id,
          impressions
        ),
    })
  }

export const purchaseFeaturedPhotosAction =
  () => async (dispatch: AppDispatchNext, getState: AppGetState) => {
    const {
      featuredPhotosStoreFront: { products, selectedProductIndex },
    } = getState()
    dispatch(togglePaymentLoadingAction(true))
    const product = products[selectedProductIndex]
    const { result } = (await dispatch(
      placeFeaturedPhotosOrderAction(product.impressions)
    )) as unknown as ApiResult<any> // any в рамках мелкого бага, не лазу в рефакторинг АПИ витрин

    await dispatch(
      commonPaymentAction(StorefrontService.featuredPhotos, product, result)
    )
  }

export const SELECT_FEATURED_PHOTO = 'SELECT_FEATURED_PHOTO' as const

export const selectedPhotoAction = (index: number) => ({
  type: SELECT_FEATURED_PHOTO,
  index,
})

export const SELECT_PRODUCT_INDEX = 'SELECT_PRODUCT_INDEX' as const

export const selectProductIndexAction = (productIndex: number) => ({
  type: SELECT_PRODUCT_INDEX,
  productIndex,
})

export const fetchPhotoRatingActiveListPhotoAction =
  (force?: boolean): AsyncThunkAction =>
  (dispatch, getState) => {
    if (
      getState().authorizationReducer.authorized &&
      (!getState().featuredPhotosPopularity.loadedActivePhoto || force)
    ) {
      return dispatch(fetchPhotoRatingActiveListPhotoPlainAction())
    }

    return Promise.resolve()
  }

export const FETCH_ACTIVE_LIST_PHOTO = 'FETCH_ACTIVE_LIST_PHOTO' as const

export const fetchPhotoRatingActiveListPhotoPlainAction = () => ({
  type: FETCH_ACTIVE_LIST_PHOTO,
  promise: () => fetchPhotoRatingActiveListApi(),
})

export const fetchArchivedFeaturedPhotoAction =
  (): AsyncThunkAction => (dispatch, getState) => {
    const {
      featuredPhotosPopularity: { featuredPhotosList },
    } = getState()

    const inActiveFeaturePhotosList = featuredPhotosList.filter(
      (featuredPhotoItem) => featuredPhotoItem.status === Status.Inactive
    )

    return dispatch(
      fetchArchivedFeaturedPhotosPlainAction(inActiveFeaturePhotosList)
    )
  }

export const FETCH_ARCHIVE_FEATURED_PHOTO =
  'FETCH_ARCHIVE_FEATURED_PHOTO' as const

interface FetchArchivedFeaturedPhotosPlainAction extends AsyncAction {
  type: typeof FETCH_ARCHIVE_FEATURED_PHOTO
}

export const fetchArchivedFeaturedPhotosPlainAction = (
  inActiveFeaturePhotosList: definitions['FeaturedPhoto'][]
) => ({
  type: FETCH_ARCHIVE_FEATURED_PHOTO,
  promise: () => fetchArchivedFeaturedPhotoApi(inActiveFeaturePhotosList),
})

export const CLEAR_MAX_RATION_FEATURED_PHOTO =
  'CLEAR_MAX_RATION_FEATURED_PHOTO' as const

export const clearMaxRatioFeaturedPhotoAction = () => ({
  type: CLEAR_MAX_RATION_FEATURED_PHOTO,
})

export type FeaturedPhotosAction =
  | ReturnType<typeof fetchPhotoRatingActiveListPhotoPlainAction>
  | FetchArchivedFeaturedPhotosPlainAction
  | ReturnType<typeof clearMaxRatioFeaturedPhotoAction>
